/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RewardMultiplierEventTargetsResponseDto } from "./RewardMultiplierEventTargetsResponseDto";
export type RewardMultiplierEventDto = {
  /**
   * 이벤트 ID
   */
  id: string;
  /**
   * 이벤트명
   */
  name: string;
  /**
   * 정답 리워드 배수
   */
  multiplier: number;
  /**
   * 대상 설정
   */
  targets: RewardMultiplierEventTargetsResponseDto;
  /**
   * 시작일시
   */
  startAt: string;
  /**
   * 종료일시
   */
  endAt: string;
  /**
   * 상태
   */
  status: RewardMultiplierEventDto.status;
  /**
   * 생성일
   */
  createdAt: string;
  /**
   * 수정일
   */
  updatedAt: string;
};
export namespace RewardMultiplierEventDto {
  /**
   * 상태
   */
  export enum status {
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
  }
}
